// src/components/ui/BottomSheet/styles.ts
import styled from "styled-components";

export const Overlay = styled.div<{ $centered?: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  flex-direction: ${(p) => (p.$centered ? "row" : "column")};
  align-items: ${(p) => (p.$centered ? "center" : "stretch")};
  justify-content: ${(p) => (p.$centered ? "center" : "flex-end")};
  padding: ${(p) => (p.$centered ? "24px" : "0")};
`;

export const Backdrop = styled.div<{ $shown: boolean }>`
  position: absolute;
  inset: 0;
  background: rgba(16, 32, 27, 0.45);
  backdrop-filter: blur(2px);
  opacity: ${(p) => (p.$shown ? 1 : 0)};
  transition: ${(p) => p.theme.tokens.transition.fade};
`;

export const Panel = styled.div<{ $shown: boolean; $maxHeight: string }>`
  position: relative;
  background: ${(p) => p.theme.tokens.colors.surface};
  border-top-left-radius: ${(p) => p.theme.tokens.radii.sheet}px;
  border-top-right-radius: ${(p) => p.theme.tokens.radii.sheet}px;
  max-height: ${(p) => p.$maxHeight};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: calc(18px + env(safe-area-inset-bottom));
  box-shadow: ${(p) => p.theme.tokens.shadows.sheet};
  transform: translateY(${(p) => (p.$shown ? "0" : "102%")});
  transition: transform 0.32s ${(p) => p.theme.tokens.transition.spring};
`;

export const CenteredPanel = styled.div<{ $shown: boolean; $width: number }>`
  position: relative;
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: 24px;
  width: ${(p) => p.$width}px;
  max-width: 100%;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 16px;
  box-shadow: ${(p) => p.theme.tokens.shadows.modal};
  transform: ${(p) => (p.$shown ? "translateY(0) scale(1)" : "translateY(14px) scale(0.97)")};
  opacity: ${(p) => (p.$shown ? 1 : 0)};
  transition: transform 0.3s ${(p) => p.theme.tokens.transition.spring},
    ${(p) => p.theme.tokens.transition.fade};
`;
